import './App.css';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Header from './Components/Header'
import Footer from './Components/Footer'
import Main from './Components/Main'
import ScenarioBuilder from './Components/ScenarioBuilder';
// import ScenarioA from './Components/ScenarioA';
// import ScenarioB from './Components/ScenarioB';
// import ScenarioC from './Components/ScenarioC';
import About from './Components/About';
import Report from './Components/Report';



import "leaflet/dist/leaflet.css";


function App() {
  return (
    <Router>
      <Header />
      <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/scenario-builder" element={<ScenarioBuilder />} />
      {/* <Route path="/scenario-a" element={<ScenarioA />} />
      <Route path="/scenario-b" element={<ScenarioB />} />
      <Route path="/scenario-c" element={<ScenarioC />} /> */}
      <Route path="/about" element={<About />} />
      <Route path="/report" element={<Report />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
